import React from 'react';
import { Card, Placeholder, Row, Col } from 'react-bootstrap';

const PackageCardSkeleton = () => {
  return (
    <Card className="shadow-sm rounded-4 overflow-hidden border-0 my-3 w-100">
      <div className="position-relative">
        <div
          style={{ height: '200px', backgroundColor: '#dee2e6' }}
          className="w-100"
        />

        <div
          className="position-absolute top-0 end-0 px-2 py-1 fw-bold text-white"
          style={{
            backgroundColor: '#ccc',
            fontSize: '14px',
            margin: '8px',
            borderRadius: '30px',
            width: '80px',
            height: '24px',
          }}
        />

        <Row
          className="position-absolute bottom-0 w-100 g-0"
          style={{ background: '#ccc', padding: '8px 12px' }}
        >
          {[...Array(3)].map((_, idx) => (
            <Col key={idx} className="text-center">
              <div style={{ height: '20px', width: '20px', margin: '0 auto', backgroundColor: '#a0a0a0', borderRadius: '50%' }}></div>
              <div style={{ height: '10px', width: '60%', backgroundColor: '#a0a0a0', margin: '6px auto 0', borderRadius: '5px' }}></div>
            </Col>
          ))}
        </Row>
      </div>

      <Card.Body className="p-3">
        <Placeholder as="h6" animation="wave">
          <Placeholder xs={8} />
        </Placeholder>

        <Placeholder as="div" animation="wave">
          <Placeholder xs={6} />
        </Placeholder>

        <div className="d-flex align-items-center border-top pt-2 mt-2">
          <div
            style={{
              width: '36px',
              height: '36px',
              borderRadius: '50%',
              backgroundColor: '#ccc',
            }}
          />
          <div className="ms-2 w-100">
            <Placeholder as="div" animation="wave">
              <Placeholder xs={6} />
            </Placeholder>
            <Placeholder as="div" animation="wave">
              <Placeholder xs={4} />
            </Placeholder>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default PackageCardSkeleton;
